module.exports = __webpack_public_path__ + "static/media/subsidy_img.1519d20c.webp";